export const fdeRoutes = {
  overview: '/dashboard/discovery/overview',
  tasks: '/dashboard/discovery/tasks',
  settings: '/dashboard/discovery/settings',
  timeline: '/dashboard/discovery/timeline',
  people: '/dashboard/discovery/people',
  workspace: '/dashboard/discovery',
  ontology: '/dashboard/discovery',
  material: '/dashboard/discovery/workspace',
  data: '/dashboard/discovery/data',
  workflows: '/dashboard/discovery/workflows',
  outcomes: '/dashboard/discovery/outcomes',
  ontologyHistory: '/dashboard/discovery/ontology_history',
  decisions: '/dashboard/discovery/decisions',
  projects: '/dashboard/discovery/projects',
  projectMembers: '/dashboard/discovery/project_members',
  projectAgents: '/dashboard/discovery/project_agents',
  projectTasks: '/dashboard/discovery/project_tasks',
  projectTaskCategories: '/dashboard/discovery/project_task_categories',
  projectTaskComments: '/dashboard/discovery/project_task_comments',
  projectTaskDispatches: '/dashboard/discovery/project_task_dispatches',
  timelineEvents: '/dashboard/discovery/timeline_events',
  objects: '/dashboard/discovery/elements',
  ontologyClasses: '/dashboard/discovery/ontology_classes',
  ontologyInterfaces: '/dashboard/discovery/ontology_interfaces',
  linkTypes: '/dashboard/discovery/link_types',
  actionTypes: '/dashboard/discovery/action_types',
  processMaps: '/dashboard/discovery/process_maps',
  relationships: '/dashboard/discovery/relationships',
  dataBindings: '/dashboard/discovery/data_bindings',
  semanticObjects: '/dashboard/discovery/semantic_objects/query',
  evidences: '/dashboard/discovery/evidences',
  documents: '/dashboard/discovery/documents',
  projectMemory: '/dashboard/discovery/project_memory',
} as const

export function fdeProjectPath(
  path: string,
  projectId?: string | null,
  params: Record<string, string | null | undefined> = {},
) {
  const query = new URLSearchParams()
  if (projectId) query.set('project_id', projectId)
  Object.entries(params).forEach(([key, value]) => {
    if (value) query.set(key, value)
  })
  return query.size > 0 ? `${path}?${query.toString()}` : path
}
